<!-- SPDX-License-Identifier: AGPL-3.0-or-later -->

<mat-card class="tournament-card" data-cy="tournaments-list-item">
  <div class="left-color-bar"></div>
  <div class="card-content">
    <div class="card-title">
      <h3 class="card-title">{{ tournament?.name }}</h3>
    </div>
    <div class="card-description">
      <p class="card-date">
        registration ends at {{ tournament?.registrationEnd | date: 'short' }}
      </p>
    </div>
    <div class="card-actions">
      <button mat-icon-button matTooltip="Overview & Controls" (click)="overviewClicked()">
        <mat-icon class="material-icons-outlined">data_thresholding</mat-icon>
      </button>
      <button
        data-cy="open-copy-team-self-reg-link-dialog"
        mat-icon-button
        aria-label="Copy team self registration link"
        matTooltip="Copy team self registration link"
        (click)="openCopyTeamRegistrationLink()"
      >
        <mat-icon>insert_link</mat-icon>
      </button>
      <button
        mat-icon-button
        data-cy="delete-tournament-btn"
        (click)="openConfirmDialog()"
        aria-label="Delete tournament"
        matTooltip="Delete tournament"
      >
        <mat-icon>delete</mat-icon>
      </button>
    </div>
  </div>
</mat-card>
